<div
    class="notifications-component-wrapper notifications-component-wrapper--fixed-v2 {{ this.currentNotificationLevel }}"
    [hidden]="notifications && activeNotifications.length < 1"
    [ngClass]="{
        'notifications-component-wrapper--fixed-v2-double': columnLayout === 'double' && !settings.ChatActive,
    }">
    <div
        class="notifications-component-item notifications-component-carousel {{ this.currentNotificationLevel }}"
        [ngClass]="{
            'notifications-component-carousel--hide': !notifications || (notifications && activeNotifications.length <= 1),
        }">
        <i
            class="icon-ic-chevron-s1 chevron-flipped"
            *ngIf="notifications && activeNotifications.length > 1"
            (click)="onPrevNotification()"></i>
        <div class="notifications-count">
            <div>
                {{ notifications && activeNotifications.length }} Notification<span
                    *ngIf="notifications && activeNotifications.length !== 1"
                    >s</span
                >
            </div>
            <div class="notifications-count-nums">({{ currentNotificationIndex + 1 }} of {{ activeNotifications.length }})</div>
        </div>
        <i class="icon-ic-chevron-s1" *ngIf="notifications && activeNotifications.length > 1" (click)="onNextNotification()"></i>
    </div>

    <!-- Central container -->

    <div
        class="notifications-component-item notifications-component-item--center notifications-component-main {{
            this.currentNotificationLevel
        }}">
        <ng-template notification-item></ng-template>
    </div>

    <!-- Dismissible container -->
    <div class="notifications-component-item notifications-component-item--right notifications-component-dismissible">
        <div *ngIf="dismissible" (click)="onDismiss(currentNotificationIndex)" class="btn-area">
            <i class="icon-ic-close-s1"></i>
            <div>Dismiss</div>
        </div>
    </div>
</div>
